import {NgModule, Optional, SkipSelf} from '@angular/core';
import {HttpClientModule} from '@angular/common/http';

import {AuthGuard} from './guard/auth.guard';
import {throwIfAlreadyLoaded} from './guard/module-import.guard';
import {AnalyticsService} from '@app/service/util/analytics.service';
import {LoggerService} from '@app/service/logger/logger.service';
import {LogPublishersService} from '@app/service/logger/log-publishers.service';
import {NzNotificationService} from 'ng-zorro-antd/notification';
import {NgxWebstorageModule} from 'ngx-webstorage';
import {StorageService} from '@app/service/util/storage.service';
import {NoAuthGuard} from '@app/guard/no-auth.guard';
import {PerformanceService} from '@app/service/util/performance.service';
import {SentryErrorService} from '@app/service/sentry-error/sentry-error.service';
import {AppUpdateService} from '@app/service/app-update/app.update.service';
import {NzModalModule} from 'ng-zorro-antd/modal';
import {NzDrawerModule} from 'ng-zorro-antd/drawer';

@NgModule({
  imports: [
    HttpClientModule,
    NgxWebstorageModule.forRoot(),
    NzModalModule,
    NzDrawerModule
  ],
  providers: [
    AuthGuard,
    NoAuthGuard,
    AnalyticsService,
    LoggerService,
    LogPublishersService,
    NzNotificationService,
    StorageService,
    PerformanceService,
    SentryErrorService,
    AppUpdateService
  ]
})
export class CoreModule {
  constructor(@Optional() @SkipSelf() parentModule: CoreModule) {
    throwIfAlreadyLoaded(parentModule, 'CoreModule');
  }
}
